import React from 'react';
import {alpha} from '@mui/material/styles';
import {NodeType} from 'crqlar-react-common/dist/models/automation/automation';
import {useTranslation} from 'react-i18next';

import {ElementChip} from '../../../common/uiElements/base/ElementChip';
import {getNodeColor, getNodeDisplay} from '../config/nodeCategories';

const ICON_SIZE = 15;

interface NodeTypeElementProps {
    nodeType: NodeType | undefined;
}

/** Icon, label and tint come from `nodeCategories`, so a new node type needs nothing here. */
export function NodeTypeElement({nodeType}: NodeTypeElementProps) {
    const {t} = useTranslation();

    if (!nodeType) return null;

    const config = getNodeDisplay(nodeType);
    const color = getNodeColor(nodeType);

    return (
        <ElementChip
            text={t(config.label)}
            startIcon={React.cloneElement(config.icon, {sx: {fontSize: ICON_SIZE, color}})}
            borderColor={alpha(color, 0.34)}
            backgroundColor={alpha(color, 0.06)}
        />
    );
}

export default NodeTypeElement;
